import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NzUploadFile, UploadFileStatus } from 'ng-zorro-antd/upload';
import { DeveloperScorecardService } from "@shared/services/developer-scorecard.service";
import { SharedStateService } from "@shared/components/modals/export-developer-data-modal/shared-state.service";

@UntilDestroy()
@Component({
  selector: 'app-export-developer-data-modal',
  templateUrl: './export-developer-data-modal.component.html',
  styleUrls: ['./export-developer-data-modal.component.scss']
})
export class ExportDeveloperDataModalComponent implements OnInit, OnDestroy {

  @Input() metricType: string;
  @Input() developerId: string;
  @Input() selectedDate: any;
  @Input() title: string
  sorting: any = {};
  searchByValues: any = {};
  intervalId: any;
  isLoadingExport = false;

  fileList: NzUploadFile[] = [];

  constructor(private developerScorecardService: DeveloperScorecardService,
              private sharedStateService: SharedStateService) { }

  ngOnInit(): void {
    this.sharedStateService.currentSorting.subscribe(sorting => this.sorting = sorting);
    this.sharedStateService.currentSearch.subscribe(search => this.searchByValues = search);
    this.getDataDeveloperList();
    this.intervalId = setInterval(() =>  this.getDataDeveloperList(), 5000);
  }

  downloadDeveloperFile = (file: NzUploadFile) => {
    this.developerScorecardService.downloadExportDeveloperData(file.uid)
      .subscribe(response => {
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch && fileNameMatch.length > 1) {
            const fileName = fileNameMatch[1];
            const blob = new Blob([response.body], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
          }
        }
      });
  }

  deleteExportedDeveloperData = (file: NzUploadFile) => {
    this.developerScorecardService.deleteDownloadExportDeveloperData(file.uid).subscribe(item => {
      this.fileList = this.fileList.filter(fileItem => fileItem.uid !== file.uid);
    });
  }

  private getDataDeveloperList() {
    this.developerScorecardService.getExportDataListByDeveloper(this.developerId, this.metricType).subscribe(response => {
      const tmpList = [];
      response.forEach(item => {
        tmpList.push({
          uid: item.id,
          name: item.fileName,
          status: item.exportStatus === 'IN_PROGRESS' ? 'uploading' : (item.exportStatus === 'COMPLETED' ? 'done' : 'error')
        });
      });
      this.fileList = tmpList;
      this.isLoadingExport = this.fileList.filter(item => item.status === 'uploading').length > 0;
    });
  }

  exportDeveloperData() {
    this.developerScorecardService.exportDeveloper(
      this.developerId,
      this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
      this.metricType,
      this.sorting,
      this.searchByValues,
    ).subscribe(item => {
      this.getDataDeveloperList();
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

}
